module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/gmat/sections/features/assets/star_icon-4ac4c15dae6171cbfaaee7af83715e37.svg";